module.exports = __webpack_public_path__ + "static/media/genwest-small-banner-image-2x.32bc603d.jpg";